import { emailRegex } from '../email-input/email-input.controller';
import { MultiEmailTextAreaProps } from './multi-email-text-area.component';

interface ViewProps {
    validateEmail: (value: string) => boolean;
    placeholder: string;
}

const useMultiEmailTextArea = (props: MultiEmailTextAreaProps): ViewProps => {
    const regex = props.customEmailRegex ?? emailRegex;

    const validateEmail = (value: string): boolean => {
        return regex.test(value);
    };

    const placeholder = props.placeholder ?? 'Enter email addresses...';

    return {
        validateEmail,
        placeholder
    };
};

export default useMultiEmailTextArea;
